export const MAP_GEOFENCES_EDIT_CREATE_OPEN_MODAL = "MAP_GEOFENCES_EDIT_CREATE_OPEN_MODAL";
export const MAP_GEOFENCES_GET_GEOFENCE = "MAP_GEOFENCES_GET_GEOFENCE";
export const MAP_GEOFENCES_GET_GEOFENCE_RESPONSE = "MAP_GEOFENCES_GET_GEOFENCE_RESPONSE"
export const MAP_GEOFENCES_EDIT_CREATE_GEOFENCE = "MAP_GEOFENCES_EDIT_CREATE_GEOFENCE";
export const MAP_GEOFENCES_EDIT_CREATE_GEOFENCE_RESPONSE = "MAP_GEOFENCES_EDIT_CREATE_GEOFENCE_RESPONSE";